/** @file Re-raises the first collected Pose2DError (from a format validateDoc rule) through throwError. */
import { throwError } from '@pose2d/format/throwError';
import type { Pose2DError } from '@pose2d/format/types';

/** Throws `errors[0]` with its code, params, path and hint; returns when the list is empty. */
export function throwFirstError(errors: readonly Pose2DError[]): void {
  const e = errors[0];
  if (e === undefined) return;
  throwError(e.code, e.params, { ...(e.path === undefined ? {} : { path: e.path }), ...(e.hint === undefined ? {} : { hint: e.hint }) });
}
